import { useQueryErrorResetBoundary } from "@tanstack/react-query";
import { ErrorBoundary } from "react-error-boundary";
import { reportBoundaryError } from "@/components/report-boundary-error";
import { Button } from "@/components/ui/button";

export function QueryErrorBoundary({
  children,
}: {
  children: React.ReactNode;
}) {
  const { reset } = useQueryErrorResetBoundary();

  return (
    <ErrorBoundary
      onReset={reset}
      onError={reportBoundaryError}
      fallbackRender={({ resetErrorBoundary }) => (
        <div className="flex h-screen flex-col items-center justify-center gap-2">
          <p className="text-sm text-destructive">Something went wrong.</p>
          <Button variant="outline" size="sm" onClick={resetErrorBoundary}>
            Try again
          </Button>
        </div>
      )}
    >
      {children}
    </ErrorBoundary>
  );
}
